export default "__VITE_ASSET__CcJlc2ar__"